/**
 * Reia — wishlist lead capture
 * Moved out of snippets/reia-wishlist-lead-capture.liquid (was inline on every page) so it is cached between page views.
 */
var REIA_SHOP = window.reiaShopDomain || '';
(function () {
  if (window.__reiaWlIdInit) return;
  window.__reiaWlIdInit = true;

  var SHOP = REIA_SHOP;
  var TOKEN_KEY = 'reia_wl_guest'; // must match extensions/wishlist/assets/wishlist.js
  var SETTINGS_CACHE_KEY = 'reia_wl_settings_cache';
  var SETTINGS_TTL_MS = 10 * 60 * 1000;
  var PROMPT_SHOWN_KEY = 'reia_wl_prompt_last_shown'; // localStorage — last time the add-triggered prompt auto-opened
  var PROMPT_INTERVAL_MS = 24 * 60 * 60 * 1000;
  var KWIKPASS_HINT_KEY = 'reia_wl_kwikpass_phone_hint'; // sessionStorage — prefill only, never trusted for linking

  var sendUrl = '/apps/reia-booking/api/otp/send?shop=' + SHOP;
  var verifyUrl = '/apps/reia-booking/api/otp/verify?shop=' + SHOP;
  var leadsUrl = '/apps/reia-booking/api/leads?shop=' + SHOP;

  var modal = document.getElementById('reia-wlid-modal');
  var stepPhone = document.getElementById('reia-wlid-step-phone');
  var stepOtp = document.getElementById('reia-wlid-step-otp');
  var stepSuccess = document.getElementById('reia-wlid-step-success');
  var phoneTitle = document.getElementById('reia-wlid-phone-title');
  var phoneSubtitle = document.getElementById('reia-wlid-phone-subtitle');
  var phoneEl = document.getElementById('reia-wlid-phone');
  var phoneErr = document.getElementById('reia-wlid-phone-error');
  var sendBtn = document.getElementById('reia-wlid-send-btn');
  var sendLabel = document.getElementById('reia-wlid-send-label');
  var otpInput = document.getElementById('reia-wlid-otp-input');
  var otpErr = document.getElementById('reia-wlid-otp-error');
  var otpSubtitle = document.getElementById('reia-wlid-otp-subtitle');
  var verifyBtn = document.getElementById('reia-wlid-verify-btn');
  var resendBtn = document.getElementById('reia-wlid-resend-btn');
  var successTitle = document.getElementById('reia-wlid-success-title');
  var successText = document.getElementById('reia-wlid-success-text');
  var closeBtn = document.querySelector('[data-reia-wlid-close]');

  // Move to <html> so no ancestor stacking context clips it.
  if (modal.parentNode !== document.documentElement) document.documentElement.appendChild(modal);

  var otpPhone = '';
  var mode = 'signup'; // 'signup' | 'restore'
  var timer = null;
  var closeTimer = null;

  var COPY = {
    signup: {
      title: "Don't lose this list",
      subtitle: "Verify your number so your wishlist is always here — on this device, and any other.",
      successTitle: "You're all set",
      successText: "Your wishlist will be here whenever you come back — on any device."
    },
    restore: {
      title: 'Restore your wishlist',
      subtitle: "Verify the number you used before and we'll bring your saved items to this device.",
      successTitle: 'Welcome back',
      successText: 'Your wishlist has been restored on this device.'
    }
  };

  function normalizePhone(raw) { return '+91' + (raw || '').replace(/\D/g, '').slice(-10); }
  function isValidPhone(raw) {
    var d = (raw || '').replace(/\D/g, '');
    return d.length === 10 && /^[6-9]/.test(d);
  }

  function getGuestToken() {
    try {
      var t = localStorage.getItem(TOKEN_KEY);
      if (t) return t;
      t = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() :
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (Math.random() * 16) | 0;
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
      localStorage.setItem(TOKEN_KEY, t);
      return t;
    } catch (e) { return null; }
  }

  function closeAll() {
    modal.classList.remove('active');
    clearInterval(timer);
    clearTimeout(closeTimer);
  }
  function showStep(step) {
    stepPhone.style.display = step === 'phone' ? '' : 'none';
    stepOtp.style.display = step === 'otp' ? '' : 'none';
    stepSuccess.style.display = step === 'success' ? '' : 'none';
  }
  function startTimer() {
    var secs = 60;
    resendBtn.disabled = true;
    resendBtn.textContent = 'Resend in ' + secs + 's';
    clearInterval(timer);
    timer = setInterval(function () {
      secs--;
      resendBtn.textContent = secs > 0 ? 'Resend in ' + secs + 's' : 'Resend code';
      if (secs <= 0) { clearInterval(timer); resendBtn.disabled = false; }
    }, 1000);
  }

  // Belt-and-suspenders on top of the server-rendered "unless customer" Liquid
  // guard above: that only runs at page-render time, but kwikpass logs shoppers in
  // via a POPUP with no full page reload (per header-reia-mega-nav.liquid's
  // own comment) — so a shopper who logs in mid-session, on a page that
  // rendered before their login, would otherwise still have this snippet's
  // listeners live. Re-check live, right before ever showing UI. Memoized:
  // once confirmed a customer, never re-checks (a real login never reverts
  // mid-session).
  var knownCustomer = false;
  // Set true the moment a phone is verified/linked (this session or from a
  // fresh server check at boot — see refreshPhoneVerifiedState). The sign-up
  // trigger can fire (once per 24h, on an add) only while this stays false;
  // once true, it stops for good.
  var phoneVerifiedKnown = false;
  function isLoggedInCustomer() {
    if (knownCustomer) return Promise.resolve(true);
    var token = getGuestToken();
    return fetch('/apps/wishlist?guest_token=' + encodeURIComponent(token), {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (data) {
      var isCustomer = !!(data && data.isCustomer);
      if (isCustomer) knownCustomer = true;
      return isCustomer;
    }).catch(function () { return false; }); // best-effort only — never blocks on a network hiccup
  }

  // onShown runs only if the modal actually opened (not skipped for a
  // customer or an already-open modal) — used to stamp the daily cap.
  function openModal(m, onShown) {
    // Don't reset an in-progress modal (e.g. mid-OTP-entry) if another
    // wishlist action fires the trigger again in the meantime.
    if (modal.classList.contains('active')) return;
    isLoggedInCustomer().then(function (isCustomer) {
      if (isCustomer) return; // now a real Shopify customer — nothing to show
      if (modal.classList.contains('active')) return; // re-check after the async gap
      openModalUi(m);
      if (onShown) onShown();
    });
  }

  function openModalUi(m) {
    mode = (m === 'restore') ? 'restore' : 'signup';
    var copy = COPY[mode];
    phoneTitle.textContent = copy.title;
    phoneSubtitle.textContent = copy.subtitle;
    phoneErr.textContent = '';
    phoneEl.value = '';
    try {
      var hint = sessionStorage.getItem(KWIKPASS_HINT_KEY);
      if (hint) phoneEl.value = hint.replace(/\D/g, '').slice(-10);
    } catch (e) {}
    showStep('phone');
    modal.classList.add('active');
    setTimeout(function () { phoneEl.focus(); }, 100);
  }

  closeBtn.addEventListener('click', closeAll);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeAll(); });

  phoneEl.addEventListener('input', function () {
    this.value = this.value.replace(/\D/g, '').slice(0, 10);
    if (phoneErr.textContent) phoneErr.textContent = '';
  });
  phoneEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') sendBtn.click(); });

  function sendOtp() {
    return fetch(sendUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: otpPhone })
    }).then(function (r) { return r.json(); });
  }

  sendBtn.addEventListener('click', function () {
    phoneErr.textContent = '';
    if (!isValidPhone(phoneEl.value)) {
      phoneErr.textContent = 'Please enter a valid 10-digit number.';
      return;
    }
    otpPhone = normalizePhone(phoneEl.value);
    sendBtn.disabled = true;
    sendLabel.textContent = 'Sending…';
    sendOtp().then(function (res) {
      sendBtn.disabled = false;
      sendLabel.textContent = 'Verify with WhatsApp';
      if (res && res.success) {
        var d = otpPhone.replace('+91', '');
        otpSubtitle.textContent = 'We sent a 6-digit code to +91 ' + d.slice(0, 5) + ' ' + d.slice(5) + ' on WhatsApp.';
        otpInput.value = '';
        otpErr.textContent = '';
        showStep('otp');
        setTimeout(function () { otpInput.focus(); }, 100);
        startTimer();
      } else {
        phoneErr.textContent = (res && res.error) || 'Unable to send code. Please try again.';
      }
    }).catch(function () {
      sendBtn.disabled = false;
      sendLabel.textContent = 'Verify with WhatsApp';
      phoneErr.textContent = 'Unable to send code. Please try again.';
    });
  });

  resendBtn.addEventListener('click', function () {
    resendBtn.disabled = true;
    otpErr.textContent = '';
    sendOtp().then(function (res) {
      if (res && res.success) { otpInput.value = ''; startTimer(); }
      else { otpErr.textContent = (res && res.error) || 'Unable to resend.'; resendBtn.disabled = false; }
    }).catch(function () { otpErr.textContent = 'Unable to resend.'; resendBtn.disabled = false; });
  });

  otpInput.addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 6); });
  otpInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') verifyBtn.click(); });

  // Fire-and-forget: never blocks the success state on the leads pipeline.
  function captureLead() {
    var sessionId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() :
      Date.now().toString(36) + Math.random().toString(36).slice(2);
    var attribution = window.reiaGetClickAttribution ? window.reiaGetClickAttribution() : null;
    try {
      fetch(leadsUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: sessionId,
          phone: otpPhone,
          form_type: 'wishlist',
          source: mode === 'restore' ? 'wishlist_restore' : 'wishlist_signup',
          page_url: window.location.href,
          metadata: attribution || undefined
        }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  // Link the verified phone to this device's guest wishlist (merges any
  // other device's history in, if that phone's already known). Never trusts
  // the client's own "verified" claim — the wishlist app re-checks it.
  function linkPhone() {
    var token = getGuestToken();
    return fetch('/apps/wishlist/phone?guest_token=' + encodeURIComponent(token), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: otpPhone })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.ok && data.guestToken && data.guestToken !== token) {
        try { localStorage.setItem(TOKEN_KEY, data.guestToken); } catch (e) {}
      }
      return data;
    });
  }

  verifyBtn.addEventListener('click', function () {
    var code = otpInput.value.trim();
    if (code.length !== 6) { otpErr.textContent = 'Please enter the 6-digit code.'; return; }
    otpErr.textContent = '';
    verifyBtn.disabled = true;
    verifyBtn.textContent = 'Verifying…';
    fetch(verifyUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: otpPhone, code: code })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || !res.success) {
        otpErr.textContent = (res && res.error) || 'Incorrect code. Please try again.';
        verifyBtn.disabled = false;
        verifyBtn.textContent = 'Verify';
        return;
      }
      return linkPhone().then(function (linked) {
        captureLead();
        phoneVerifiedKnown = true;
        hideRestoreLink(); // nothing left to restore on this device now
        var copy = COPY[mode];
        successTitle.textContent = copy.successTitle;
        successText.textContent = (linked && linked.merged) ? copy.successText + ' We found your earlier list and brought it in.' : copy.successText;
        showStep('success');
        verifyBtn.disabled = false;
        verifyBtn.textContent = 'Verify';
        var onWishlistPage = !!document.querySelector('[data-reia-wishlist-page]');
        var shouldReload = linked && (linked.merged || mode === 'restore') && onWishlistPage;
        closeTimer = setTimeout(function () {
          closeAll();
          if (shouldReload) window.location.reload();
        }, 1800);
      });
    }).catch(function () {
      otpErr.textContent = 'Verification failed. Please try again.';
      verifyBtn.disabled = false;
      verifyBtn.textContent = 'Verify';
    });
  });

  // ── Phone-capture kill switch: read once per page, short client cache ──
  function readSettingsCache() {
    try {
      var raw = localStorage.getItem(SETTINGS_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || (Date.now() - parsed.at) > SETTINGS_TTL_MS) return null;
      return parsed.enabled;
    } catch (e) { return null; }
  }
  function writeSettingsCache(enabled) {
    try { localStorage.setItem(SETTINGS_CACHE_KEY, JSON.stringify({ enabled: enabled, at: Date.now() })); } catch (e) {}
  }
  function fetchPhoneCaptureEnabled() {
    var cached = readSettingsCache();
    if (cached !== null) return Promise.resolve(cached);
    var token = getGuestToken();
    return fetch('/apps/wishlist?guest_token=' + encodeURIComponent(token), {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (data) {
      var enabled = !!(data && data.settings && data.settings.phoneCaptureEnabled !== false);
      writeSettingsCache(enabled);
      return enabled;
    }).catch(function () { return true; }); // fail open — a network hiccup shouldn't silently disable the feature
  }

  // ── Kwikpass-trust auto-link (Phase 5b) ──
  // Kwikpass's login doesn't bridge to a real Shopify customer session on
  // this store, so logged-in Kwikpass shoppers still look like guests to us.
  // Kwikpass stores its own verified-phone signal client-side once its OTP
  // completes: `notifyph` (base64 "countrycode|number"), gated on
  // kp_session_type === "verified" and kp_valid_session === "true". We read
  // it and ask the server to auto-link it — but the server-side rule is what
  // actually matters (see autoLinkPhoneFromTrustedClient): this value is a
  // plain, forgeable cookie/localStorage read, NOT a signed Shopify signal,
  // so it only silently succeeds for a brand-new phone. If the phone already
  // has an existing wishlist to protect, the server refuses and we fall back
  // to prefilling it into our own real OTP flow instead of trusting it.
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getKwikpassVerifiedPhone() {
    try {
      var sessionType = readCookie('kp_session_type') || localStorage.getItem('kp_session_type');
      var validSession = readCookie('kp_valid_session') || localStorage.getItem('kp_valid_session');
      if (sessionType !== 'verified' || String(validSession) !== 'true') return null;
      var raw = readCookie('notifyph') || localStorage.getItem('notifyph');
      if (!raw) return null;
      var decoded = atob(raw);
      var parts = decoded.split('|');
      if (parts.length !== 2 || !parts[1]) return null;
      return (parts[0] + parts[1]).replace(/\s+/g, '');
    } catch (e) { return null; }
  }
  function attemptKwikpassAutoLink() {
    var phone = getKwikpassVerifiedPhone();
    if (!phone) return Promise.resolve();
    var token = getGuestToken();
    return fetch('/apps/wishlist/phone/auto?guest_token=' + encodeURIComponent(token), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: phone })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.ok) {
        phoneVerifiedKnown = true;
        if (data.guestToken && data.guestToken !== token) {
          try { localStorage.setItem(TOKEN_KEY, data.guestToken); } catch (e) {}
        }
      } else if (data && data.error === 'needs_verification') {
        // Someone else already holds this phone in our system — remember it
        // as a prefill hint only; real linking still requires our own OTP.
        try { sessionStorage.setItem(KWIKPASS_HINT_KEY, phone); } catch (e) {}
      }
    }).catch(function () {});
  }

  // ── Shared "is this device's phone verified yet" check ──
  // Runs on every page (not just the wishlist page) so the sign-up trigger
  // knows, site-wide, whether to keep firing. Also syncs the wishlist page's
  // "Restore"/"Save" button when present:
  //   - device already has items  → "Save your wishlist" (link this phone,
  //     forward-looking — nothing to restore, but still needs protecting)
  //   - device is empty           → "Restore your wishlist" (pull in from
  //     another device via the same phone)
  function hideRestoreLink() {
    var btn = document.querySelector('[data-reia-wl-restore]');
    if (btn) btn.hidden = true;
  }
  function refreshPhoneVerifiedState() {
    var token = getGuestToken();
    return fetch('/apps/wishlist?guest_token=' + encodeURIComponent(token), {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (data) {
      var isCustomer = !!(data && data.isCustomer);
      if (isCustomer) knownCustomer = true; // memoize — covers the same mid-session-login race as openModal's guard
      phoneVerifiedKnown = !!(data && data.phoneVerified);
      var btn = document.querySelector('[data-reia-wl-restore]');
      if (btn) {
        var enabled = !!(data && data.settings && data.settings.phoneCaptureEnabled !== false);
        var hasItems = !!(data && data.count > 0);
        var shouldShow = !isCustomer && enabled && !phoneVerifiedKnown;
        btn.hidden = !shouldShow;
        if (shouldShow) {
          var mode = hasItems ? 'signup' : 'restore';
          btn.textContent = hasItems ? 'Save your wishlist' : 'Restore your wishlist';
          btn.setAttribute('data-reia-wl-restore-mode', mode);
        }
      }
    }).catch(function () { /* leave state as-is on error */ });
  }

  // ── Sign-up trigger: a LIVE wishlist add, at most once per 24h ──
  // Fires only when the shopper adds an item (never on page load or a
  // removal), and only if the prompt hasn't auto-shown on this device in the
  // last 24h. Stops for good once this device's phone is verified.
  function promptShownRecently() {
    try {
      var last = parseInt(localStorage.getItem(PROMPT_SHOWN_KEY), 10);
      return !isNaN(last) && (Date.now() - last) < PROMPT_INTERVAL_MS;
    } catch (e) { return false; }
  }
  function markPromptShown() {
    try { localStorage.setItem(PROMPT_SHOWN_KEY, String(Date.now())); } catch (e) {}
  }
  function bindSignupTrigger() {
    var baselineSet = false;
    var baseline = 0;
    document.addEventListener('reia:wishlist:count', function (e) {
      if (phoneVerifiedKnown) return;
      var count = (e.detail && e.detail.count) || 0;
      if (!baselineSet) { baselineSet = true; baseline = count; return; }
      if (count > baseline && !promptShownRecently()) {
        openModal('signup', markPromptShown);
      }
      baseline = count;
    });
  }

  // ── Restore/save trigger: explicit, always available (no cooldown) — but
  // still respects the merchant kill-switch, same as the sign-up trigger.
  // Mode ('restore' when this device is empty, 'signup' when it already has
  // items — see refreshPhoneVerifiedState) comes from the button itself.
  var phoneCaptureEnabled = null; // null = not yet known
  document.addEventListener('reia-wl-restore:open', function (e) {
    var mode = (e.detail && e.detail.mode) || 'restore';
    if (phoneCaptureEnabled === false) return;
    if (phoneCaptureEnabled === null) {
      fetchPhoneCaptureEnabled().then(function (enabled) { if (enabled) openModal(mode); });
      return;
    }
    openModal(mode);
  });

  fetchPhoneCaptureEnabled().then(function (enabled) {
    phoneCaptureEnabled = enabled;
    if (!enabled) return;
    // Attempt the Kwikpass auto-link BEFORE binding the sign-up trigger and
    // refreshing verified state, so a successful silent link is reflected
    // immediately rather than flashing the prompt first.
    attemptKwikpassAutoLink().then(function () {
      bindSignupTrigger();
      refreshPhoneVerifiedState();
    });
  });
})();
